import { useState } from 'react';

import { colors } from 'inpock-ui-react/dist/src/color';
import { Paragraph2, SmallText, SmallText2 } from 'inpock-ui-react';

import { DashDivider, Icon } from '@/components';

import { ConsentForm, FormProps } from '../types';

import * as S from './styled';

interface ConsentFormProps extends FormProps<ConsentForm> {}

export function ConsentSection(props: ConsentFormProps) {
  const { form } = props;
  const [isFold, setIsFold] = useState<boolean>(false);

  return (
    <S.SectionBody>
      <S.ConsentLine
        justifyContnt="flex-start"
        onClick={() => {
          Object.values(form).every((v) => v)
            ? props.setForm({
                terms_comfirm: false,
                privacy_confirm: false,
                order_confirm: false,
                years_confirm: false,
                non_members_confirm: false,
              })
            : props.setForm({
                terms_comfirm: true,
                privacy_confirm: true,
                order_confirm: true,
                years_confirm: true,
                non_members_confirm: true,
              });
        }}
      >
        <Icon
          icon="CheckSmall"
          size={24}
          viewBox="0 0 24 24"
          color={Object.values(form).every((v) => v) ? colors.orange : colors.gray200}
        />
        <Paragraph2 className="ml-10 cursor">모두 동의합니다</Paragraph2>
      </S.ConsentLine>
      <DashDivider color={colors.gray300} />
      <S.ConsentLine>
        <S.ConsentLabel
          onClick={() =>
            props.setForm((prev) => {
              return { ...prev, terms_comfirm: !prev.terms_comfirm };
            })
          }
        >
          <Icon
            icon="CheckSmall"
            size={24}
            viewBox="0 0 24 24"
            color={form.terms_comfirm ? colors.orange : colors.gray200}
          />
          <Paragraph2 color="gray700" className="ml-10">
            이용약관에 동의합니다
          </Paragraph2>
        </S.ConsentLabel>
        <a href="https://terms.inpock.co.kr/link/terms" target="_blank" rel="noreferrer">
          <Icon icon="ArrowRight" size={12} color={colors.gray500} />
        </a>
      </S.ConsentLine>
      <S.ConsentLine>
        <S.ConsentLabel
          onClick={() =>
            props.setForm((prev) => {
              return { ...prev, privacy_confirm: !prev.privacy_confirm };
            })
          }
        >
          <Icon
            icon="CheckSmall"
            size={24}
            viewBox="0 0 24 24"
            color={form.privacy_confirm ? colors.orange : colors.gray200}
          />
          <Paragraph2 color="gray700" className="ml-10">
            개인정보 처리방침에 동의합니다
          </Paragraph2>
        </S.ConsentLabel>
        <a href="https://terms.inpock.co.kr/payments/privacy" target="_blank" rel="noreferrer">
          <Icon icon="ArrowRight" size={12} color={colors.gray500} />
        </a>
      </S.ConsentLine>
      <S.ConsentLine
        justifyContnt="flex-start"
        style={{ paddingLeft: '0px' }}
        onClick={() => {
          props.setForm((prev) => {
            return { ...prev, order_confirm: !prev.order_confirm };
          });
        }}
      >
        <Icon
          icon="CheckSmall"
          size={24}
          viewBox="0 0 24 24"
          color={form.order_confirm ? colors.orange : colors.gray200}
        />
        <Paragraph2 color="gray700" className="ml-10 cursor">
          위 주문의 상품, 가격, 할인, 배송정보에 동의 (전자상거래법 제 8조 2항)
        </Paragraph2>
      </S.ConsentLine>
      <S.ConsentLine>
        <S.ConsentLabel
          onClick={() =>
            props.setForm((prev) => {
              return { ...prev, years_confirm: !prev.years_confirm };
            })
          }
        >
          <Icon
            icon="CheckSmall"
            size={24}
            viewBox="0 0 24 24"
            color={form.years_confirm ? colors.orange : colors.gray200}
          />
          <Paragraph2 color="gray700" className="ml-10">
            만 14세 이상 고객입니다
          </Paragraph2>
        </S.ConsentLabel>
      </S.ConsentLine>
      <S.AccordionConsentLine
        onClick={(e) => {
          e.stopPropagation();
          setIsFold(!isFold);
        }}
      >
        <S.ConsentLabel
          onClick={(e) => {
            e.stopPropagation();

            props.setForm((prev) => {
              return { ...prev, non_members_confirm: !prev.non_members_confirm };
            });
          }}
        >
          <Icon
            icon="CheckSmall"
            size={24}
            viewBox="0 0 24 24"
            color={form.non_members_confirm ? colors.orange : colors.gray200}
          />
          <Paragraph2 color="gray700" className="ml-10">
            비회원 주문 정보 수집에 동의합니다
          </Paragraph2>
        </S.ConsentLabel>
        <Icon icon={isFold ? 'ArrowUp' : 'ArrowDown'} size={12} color={colors.gray500} />
      </S.AccordionConsentLine>
      {isFold && (
        <S.ConsentFoldContent>
          <SmallText>
            비회원으로 서비스를 이용하는 경우, 회원에게만 적용되는 사항을 제외한 나머지 부분에
            대하여는 회원과 동일하게 개인정보처리방침이 적용됩니다.
          </SmallText>
          <br />
          <br />
          <SmallText fontWeight="bold">1. 개인정보 수집 및 이용 목적</SmallText>
          <br />
          <SmallText2 color="gray700">
            a. 구매한 물품의 배송/설치 등 고객과 체결한 계약의 이행
          </SmallText2>
          <br />
          <SmallText2 color="gray700">
            b. 상품 구매 관련 문의사항과 반품 및 환불 등 민원사항의 상담 및 처리
          </SmallText2>
          <br />
          <SmallText2 color="gray700">
            c. 상품 구매 관련 고지사항, 주문/배송정보 안내{' '}
          </SmallText2>{' '}
          <br />
          <SmallText2 color="gray700">
            {' '}
            d. 대금 결제 시 수집하는 개인정보는 결제대행업체(PG사)에서 수집 및 저장 (회사는
            결제대행업체에서 제공하는 거래내역만을 제공받고 있음)
          </SmallText2>
          <br />
          <br />
          <SmallText fontWeight="bold">2. 수집하는 개인정보의 항목</SmallText> <br />
          <SmallText2 color="gray700">
            a. (필수) 14세 이상 여부, 주문자명, 이메일, 구매자 연락처, 받는 사람명, 연락처, 배송지,
            배송메시지, 결제수단정보 (신용카드, 계좌번호 등 결제수단에 따름)
          </SmallText2>
          <br />
          <br />
          <SmallText fontWeight="bold">3. 개인정보 보유 이용 기간</SmallText> <br />
          <SmallText2 color="gray700">
            a. 상품 주문 및 배송 완료 후 5년간 보유합니다. (전자상거래 등에서의 소비자 보호에 관한
            법률)
          </SmallText2>
          <br />
          <SmallText2 color="gray700">
            b. 법령에 따라 보유하여야 하는 기간은 홈페이지 하단의 ‘개인정보 처리방침’을 참고하시기
            바랍니다.
          </SmallText2>
        </S.ConsentFoldContent>
      )}

      <Paragraph2 className="mt-16" color="gray300">
        고객님께서는 위와 같은 개인정보 수집에 동의를 거부하실 수 있습니다. <br />
        다만, 필수 항목 동의 거부 시 서비스 이용이 제한됩니다.
      </Paragraph2>
    </S.SectionBody>
  );
}
